// extracted by mini-css-extract-plugin
export default {"flexContainer":"LegendTextFormatter_flexContainer__fI5LC","legendDot":"LegendTextFormatter_legendDot__FJ2BQ","legendLabel":"LegendTextFormatter_legendLabel__wcX+m"};